import { defaultClient as ApolloClient } from "../../../main";
import { GET_USERS } from "../../../graphql/user/userQ";
import {
  USER_MERGE,
  USER_DELETE,
  SIGN_IN_USER,
  GET_CURRENT_USER
} from "../../../graphql/user/userM";
import router from "../../../router/router";

export const actions = {
  allUser: async ({ commit }, payload) => {
    // commit("setLoading", true);
    await ApolloClient.query({
      query: GET_USERS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setUsersList", data.allUser);
        // commit("setLoading", false);
      })
      .catch(err => {
        // commit("setLoading", false);
        console.error(err);
      });
  },

  userDelete: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: USER_DELETE,
      variables: {
        userId: payload.userId
      },
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_USERS
          });

          data.allUser.edges = data.allUser.edges.filter(
            user => +user.node.userId !== payload.userId
          );

          cache.writeQuery({
            query: GET_USERS,
            data
          });
        } catch (error) {
          console.error(`Error in userDelete update hook. Full info: ${error}`);
        }
      }
    })
      .then(() => {
        dispatch("allUser");
      })
      .catch(err => {
        console.error(`Error in userDelete action. Full info => ${err}`);
      });
  },
  userMerge: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: USER_MERGE,
      variables: payload,
      update: (cache, { data: { userMerge } }) => {
        try {
          const data = cache.readQuery({
            query: GET_USERS
          });
          console.log(data);
          data.allUser.edges.push(userMerge);
          cache.writeQuery({
            query: GET_USERS,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook from userMerge action. Full info ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allUser");
      })
      .catch(err => {
        console.error(`Error in userMerge action. Full info ${err}`);
      });
  },
  userUpdate: async ({ dispatch }, payload) => {
    return ApolloClient.mutate({
      mutation: USER_MERGE,
      variables: payload,
      update: cache => {
        try {
          const data = cache.readQuery({
            query: GET_USERS
          });
          const currentUser = data.allUser.edges.filter(
            user => +user.node.userId === +payload.userId
          );
          const userIndx = data.allUser.edges.indexOf(currentUser[0]);
          //TODO Take this logic for all update actions
          if (userIndx !== -1) {
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(
              data.allUser.edges[userIndx].node
            )) {
              // eslint-disable-next-line no-unused-vars
              for (let [newKey, newValue] of Object.entries(payload)) {
                if (key === newKey) {
                  data.allUser.edges[userIndx].node[key] = payload[newKey];
                }
              }
            }
          } else {
            console.error("No index for update hook in userUpdate action");
          }
          cache.writeQuery({
            query: GET_USERS,
            data
          });
        } catch (error) {
          console.error(
            `Error in update hook from userUpdate action. Full info ${error}`
          );
        }
      }
    })
      .then(() => {
        dispatch("allUser");
      })
      .catch(err => {
        console.error(`Error in userMerge action. Full info ${err}`);
      });
  },
  /********************************************************/
  /***********AUTHENTICATION BLOCK*************************/

  signInUser: async ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    localStorage.setItem("graphqlError", "");

    try {
      const { data } = await ApolloClient.mutate({
        mutation: SIGN_IN_USER,
        variables: payload
      });

      const userDetails = data.signInUser.userDetails;
      localStorage.setItem("token", userDetails.accessToken);
      localStorage.setItem("userId", userDetails.userId);
      localStorage.setItem("userId22", userDetails.userId);
      localStorage.setItem("refresh_token", userDetails.refreshToken);

      const userData = await ApolloClient.query({
        query: GET_USERS,
        variables: { userId: userDetails.userId }
      });

      const userAccess =
        userData.data.allUser.edges[0] &&
        userData.data.allUser.edges[0].node.userAccess.edges[0] &&
        userData.data.allUser.edges[0].node.userAccess.edges[0].node;

      if (userAccess && userAccess.clubId !== undefined) {
        localStorage.setItem("clubId", userAccess.clubId);
      }

      router.go();

      commit("setLoading", false);
    } catch (err) {
      commit("setLoading", false);
      commit("setError", err.message);
      localStorage.setItem("graphqlError", err.message);
      console.error(err);
    }
  },

  signUpUser: async ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    // clear token to prevent any errors if malformed.

    return (
      ApolloClient.mutate({
        mutation: USER_MERGE,
        variables: payload
        //update: (client, { data: { userDetails } }) => {}
      })
        // eslint-disable-next-line
      .then(({ data }) => {
          //localStorage.setItem('token',data.signUpUser.userDetails.accessToken);
          //localStorage.setItem('userId',data.signInUser.userDetails.userId);
          //localStorage.setItem('refresh_token',data.signUpUser.userDetails.refreshToken);
          // to make sure created method is run in main.js( we run getCurrentUsser), reload page
          //router.go();
          console.log(router);
          router.push("/auth/signin").catch(err => {
            commit("setError", err);
          });
          commit("setLoading", false);
        })
        .catch(err => {
          commit("setLoading", false);
          commit("setError", err);
          console.error(`Error in signUpUser action. Full info => ${err}`);
        })
    );
  },

  signoutUser: async ({ commit }) => {
    // clear user in state
    commit("clearUser");

    // remove token in localStorage
    localStorage.setItem("token", "");
    localStorage.setItem("userId", "");
    localStorage.setItem("refresh_token", "");
    localStorage.setItem("clubId", "");

    // end session
    // console.dir(ApolloClient);
    await ApolloClient.resetStore();
    // redirect home - kick users out of private pages ( i.e. profile)
    router.push("/auth/signin").catch(err => {
      commit("setError", err);
    });
  },

  getCurrentUser: async ({ commit }, payload) => {
    commit("clearError");
    commit("setLoading", true);
    return ApolloClient.mutate({
      mutation: GET_CURRENT_USER,
      variables: payload,
      update: (client, { data: { getCurrentUser } }) => {} // eslint-disable-line
    })
      .then(({ data }) => {
        // eslint-disable-line

        // Add user data to state
        commit("setUser", data.getCurrentUser);
        commit("setLoading", false);
      })
      .catch(err => {
        //commit('setUser', null);
        //localStorage.setItem('userId','');
        commit("setLoading", false);
        commit("setError", err);
        console.error(err);
      });
  },

  getCurrentUserDetails: ({ commit }, payload) => {
    commit("setLoading", true);
    ApolloClient.query({
      query: GET_USERS,
      variables: payload
    })
      .then(({ data }) => {
        commit("setUser", data.allUser.edges[0].node);
        commit("setLoading", false);
      })
      .catch(err => {
        commit("setLoading", false);
        console.error(err);
      });
  }
};
